import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AccountInfo, LocalStorageUtil } from 'src/app/util/local-storage-util';
import { UiChangePasswordComponent } from '../ui-change-password/ui-change-password.component';
import { LoginService } from 'src/app/services/login.service';
import { WalletService } from 'src/app/modules/indication/services/wallet.service';

type MenuItem = {
  label: string;
  icon: string;
  link?: string;
  submenu: { label: string; link: string }[];
};

@Component({
  selector: 'app-ui-main-menu',
  templateUrl: './ui-main-menu.component.html',
  styleUrls: ['./ui-main-menu.component.scss'],
})
export class UiMainMenuComponent implements OnInit {
  @Input() userRegistration: any = null;

  account: AccountInfo;
  menu: MenuItem[] = [
    {
      label: 'Dashboard',
      icon: 'chart-line',
      link: '/v2/dashboard',
      submenu: [],
    },
    {
      label: 'Agendamento de consultas',
      icon: 'calendar-alt',
      link: '/v2/indications',
      submenu: [],
    },
    {
      label: 'Central de Oportunidades',
      icon: 'bullhorn',
      link: '/cases',
      submenu: [],
    },
    {
      label: 'Meus clientes',
      icon: 'users',
      link: '/patients',
      submenu: [],
    },
  ];
  private walletTimeoutId: any;
  showWallet: boolean = false;
  loading: boolean = false;
  walletAmmount: { ammount: string; isShowing: boolean } = {
    ammount: '000,00',
    isShowing: false,
  };

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private loginService: LoginService,
    private walletService: WalletService,
  ) {}

  ngOnInit(): void {
    this.loginService.startIntercom(LocalStorageUtil.getAccountInfo());

    if (this.userRegistration) {
      this.account = this.userRegistration;
      return;
    } else {
      this.account = LocalStorageUtil.getAccountInfo();

      if (this.account.admin)
        this.menu.push({
          label: 'Conta',
          icon: 'credit-card',
          submenu: [
            { label: 'Assinatura', link: '/signature' },
            { label: 'Contratante', link: '/contractor' },
            { label: 'Carteira', link: '/wallet' },
            { label: 'Usuários', link: '/users' },
            { label: 'Integrações', link: '/v2/account/integrations' },
          ],
        });
    }

    if (this.account.superAdmin) {
      this.menu.push({
        label: 'Administrativo',
        icon: 'user',
        submenu: [
          { label: 'Assumir conta', link: '/take-account' },
          { label: 'Editar indicação', link: '/edit-indication' },
          { label: 'Oportunidades', link: '/cases-admin' },
          { label: 'Contas', link: '/administrative/accounts' },
          { label: 'Indicações', link: '/administrative/indications' },
          { label: 'Sync Communicare', link: '/v2/administrative/communicare-sync-report' },
        ],
      });

      /**
      this.menu.push({
        label: 'Cadastros',
        icon: 'user',
        submenu: [
          { label: 'Especialidades', link: '/specialties' },
          { label: 'Médicos', link: '/doctors' },
        ],
      });
       */

      this.menu.push({
        label: 'Relatórios',
        icon: 'file-invoice',
        submenu: [
          {
            label: 'NPS - Indicações por Médico',
            link: '/reports/nps/indications-by-doctor',
          },
          {
            label: 'NPS - Média por Médico',
            link: '/reports/nps/average',
          },
          // { label: 'Contas', link: '/reports/users' },
          {
            label: 'Laudos Atrasados',
            link: '/reports/delayed-attendance',
          },
          {
            label: 'Relatório de Contas CSV',
            link: '/reports/accounts-csv',
          },
          {
            label: 'Contas e Usuários',
            link: '/reports/accounts-users',
          },

          // PV-1371 (Transferência Previdas) e PV-1372 (NFS-e Médico) vivem como
          // abas dentro do dashboard de Relatório Financeiro em
          // /v2/administrative/report — não como entradas separadas aqui.

          // {
          //   label: 'Notas Fiscais',
          //   link: '/reports/invoices',
          // },
        ],
      });
      /**
      this.menu.push({
        label: 'Planos',
        icon: 'chart-line',
        link: '/plans',
        submenu: []
      });
      this.menu.push({
        label: 'Procedimentos',
        icon: 'clipboard-check',
        link: '/procedure',
        submenu: []
      })
       */
    }

    if (this.account.financeiroRole) {
      this.menu
        .find((item) => item.label === 'Administrativo')
        ?.submenu.push({
          label: 'Notas Fiscais',
          link: '/administrative/indication-financial',
        });

      this.menu
        .find((item) => item.label === 'Relatórios')
        ?.submenu.push({
          label: 'Pagamentos Médicos',
          link: '/reports/doctor-payments',
        });

      this.menu.push({
        label: 'Financeiro',
        icon: 'money-check-alt',
        submenu: [
          { label: 'Carteira', link: '/v2/administrative/wallet' },
          { label: 'Relatório Financeiro', link: '/v2/administrative/report' }
        ],
      });
    }
  }

  onClick(item: { link: string }) {
    if (item.link) {
      this.router.navigate([item.link]);
    }
  }

  logout() {
    this.loginService.stopIntercom();
    window.location.href = '/login' + window.location.search;
    LocalStorageUtil.logout();
  }

  firstName(name: string) {
    return name.split(' ').length > 0 ? name.split(' ')[0] : name;
  }

  goToProfile() {
    const token = LocalStorageUtil.getToken();
    this.router.navigate([`/profile/${token}`]);
  }

  goToWallet() {
    this.router.navigate(['/wallet']);
  }

  resetPass() {
    const dialogRef = this.dialog.open(UiChangePasswordComponent);
    dialogRef.afterClosed().subscribe();
  }

  walletDetails() {
    this.clearWalletTimeout();
    this.showWallet = !this.showWallet;

    if (!this.showWallet) {
      this.loading = false;
      this.walletAmmount = {
        ammount: '000,00',
        isShowing: false,
      };
    } else {
      this.loading = true;
      this.showAmmount();
    }
  }

  showAmmount() {
    const params = { accountId: this.account.accountId };

    this.walletService.getAmount(params).subscribe({
      next: (data) => {
        const ammount = data.amount.toFixed(2).toString().replace('.', ',');
        this.showWallet = true;
        this.walletAmmount = {
          ammount,
          isShowing: true,
        };
        this.loading = false;
        this.startWalletTimeout(10000);
      },
      error: (error) => console.log(error),
    });
  }

  private startWalletTimeout(timer: number) {
    this.clearWalletTimeout();

    this.walletTimeoutId = setTimeout(() => {
      this.showWallet = false;
      this.walletAmmount = {
        ammount: '000,00',
        isShowing: false,
      };
      this.walletTimeoutId = null;
    }, timer);
  }

  private clearWalletTimeout() {
    if (this.walletTimeoutId) {
      clearTimeout(this.walletTimeoutId);
      this.walletTimeoutId = null;
    }
  }
}
